import {generateUniqueId, COLOR_GREEN } from '../constants';
import { mapDndBItemsToLairActions } from '../mappers/DndBItemsToLairActionsMapper';

const dndBNumberToString = {
    1: "Blinded Condition",  
    2: "Charmed Condition",
    3: "Deafened Condition",
    4: "Exhaustion Condition",
    5: "Frightened Condition",
    6: "Grappled Condition",
    7: "Incapacitated Condition",
    8: "Invisible Condition",
    9: "Paralyzed Condition",
    10: "Petrified Condition",
    11: "Poisoned Condition",
    12: "Prone Condition",
    13: "Restrained Condition",
    14: "Stunned Condition",
    15: "Unconscious Condition"
}

const getDnDBEffectsFromConditions = (conditions) => {
    let conditionStrings = []
    conditions.forEach(c => {
        if(dndBNumberToString[c.id] !== "Exhaustion") { //ignore exhaustion since its special
            conditionStrings.push(dndBNumberToString[c.id])
        }
    });

    return conditionStrings
}

function calcSave(skill) {
    if(!skill && skill !== 0) return 0

    return Math.floor((skill-10)/2)
}

export const DndBCharacterToDmBMapper = (dndBeyondRes, encounterGuid, skillDetails=undefined) => {
    // Full info is available from dndB

    if(skillDetails) {
        let {maxHp, armorClass, inventory, skills_json_array} = skillDetails;
        let calculatedHp = dndBeyondRes.overrideHitPoints ? dndBeyondRes.overrideHitPoints : maxHp;

        return {
            "name": dndBeyondRes.name,
            "name_default": dndBeyondRes.name,
            "from": "dnd_b",
            "creatureGuid": generateUniqueId(),
            "encounterGuid": encounterGuid,
            "status": dndBeyondRes.status === 0 ? 200 : dndBeyondRes.status,
            "dnd_b_player_id": dndBeyondRes.id.toString(),
            "link": dndBeyondRes.link,
            "avatarUrl": dndBeyondRes.decorations.avatarUrl || 'https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/humanoid.jpg',
            "hit_points": calculatedHp,
            "hit_points_default": calculatedHp,
            "hit_points_current": calculatedHp - dndBeyondRes.removedHitPoints || 0,
            "hit_points_temp": dndBeyondRes.temporaryHitPoints || 0,
            "hit_points_override": dndBeyondRes.overrideHitPoints || 0, //dnd beyonds override max hp
            "hit_points_modifier": dndBeyondRes.bonusHitPoints || 0, //dnd beyonds max hp modifier
            "initiative": 0,
            "last_damage":null,
            "death_saves_failure_count": dndBeyondRes?.deathSaves?.failCount || 0,
            "death_saves_success_count": dndBeyondRes?.deathSaves?.successCount || 0,
            "exhaustionLvl": dndBeyondRes.conditions.find(obj => obj.id === 4)?.level || 0,
            "path": "",
            "type": "player",
            "alignment": "ally",
            "groupGuid": null,
            "border": COLOR_GREEN,
            "effects": getDnDBEffectsFromConditions(dndBeyondRes.conditions),
            "creature_type": dndBeyondRes.race.fullName,
            "inspiration": dndBeyondRes.inspiration,
            "bardic_inspiration": false,
            "armor_class": armorClass || 0,
            "inventory": mapDndBItemsToLairActions(inventory),
            "skills": '',
            "spellcasting": [],
            "hidden": false,
            "environments": '',
            "legendary_actions": [],
            "lair_actions": [],
            "regional_effects": [],
            "campaign": dndBeyondRes?.campaign?.name,
            "strength": skills_json_array[0]["total score"],
            "dexterity": skills_json_array[1]["total score"],
            "constitution": skills_json_array[2]["total score"],
            "intelligence": skills_json_array[3]["total score"],
            "wisdom": skills_json_array[3]["total score"],
            "charisma": skills_json_array[4]["total score"],
            "speed": {'walk': 30},
            "condition_immunities": "",
            "strength_save": calcSave(skills_json_array[0]["total score"]),
            "dexterity_save": calcSave(skills_json_array[1]["total score"]),
            "constitution_save": calcSave(skills_json_array[2]["total score"]),
            "intelligence_save": calcSave(skills_json_array[3]["total score"]),
            "charisma_save": calcSave(skills_json_array[4]["total score"]),
            "wisdom_save": calcSave(skills_json_array[5]["total score"]),
        }

    } else {
        return {
            "name": dndBeyondRes.name,
            "name_default": dndBeyondRes.name || '',
            "level": dndBeyondRes.level || 0,
            "from": "dnd_b",
            "creatureGuid": generateUniqueId(),
            "encounterGuid": encounterGuid,
            "status": 403,
            "dnd_b_player_id": dndBeyondRes.id,
            "link": "",
            "avatarUrl": 'https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/humanoid.jpg',
            "hit_points": 10,
            "hit_points_default": 1,
            "hit_points_current": 10,
            "hit_points_temp": 0,
            "hit_points_override": 0, 
            "hit_points_modifier": 0, 
            "initiative": 0,
            "last_damage": null,
            "death_saves_failure_count": dndBeyondRes?.deathSaves?.failCount || 0,
            "death_saves_success_count": dndBeyondRes?.deathSaves?.successCount || 0,
            "exhaustionLvl": 0,
            "path": "",
            "type": "player",
            "alignment": "ally",
            "groupGuid": null,
            "border": COLOR_GREEN,
            "effects": [],
            "creature_type": dndBeyondRes.race || '',
            "inspiration": dndBeyondRes.inspiration,
            "bardic_inspiration": false,
            "armor_class": 10,
            "inventory": null,
            "skills":  [],
            "spellcasting": [],   
            "hidden": false,
            "environments": '',
            "legendary_actions": [],
            "lair_actions": [],
            "regional_effects": [],
            "campaign": null,
            "speed": {'walk': 30},
            "condition_immunities": "",
            "strength_save": 10,
            "dexterity_save": 10,
            "constitution_save": 10,
            "intelligence_save": 10,
            "charisma_save": 10,
            "wisdom_save": 10,
            "strength": 10,
            "dexterity": 10,
            "constitution": 10,
            "intelligence":10,
            "wisdom": 10,
            "charisma": 10,
        }
    }
};

export default DndBCharacterToDmBMapper;